module.exports = __webpack_public_path__ + "img/arrow-prev.78b027cf.svg";